/*eslint-disable*/
import { useMutation, useQuery } from '@tanstack/react-query';
import { AlertAdapter, DataTableCellDeleteButton, RegularButton } from 'pg-ui-library';
import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { DefaultTable } from 'src/components';
import { Background } from 'src/modules/notifications/styles';
import SettingsService from 'src/services/settings.service';

export const PayrollConfigModal: React.FC<{ payrollModal: boolean; setPayrollModal: any; companyId: string }> = ({
  payrollModal,
  setPayrollModal,
  companyId,
}) => {
  const [companyEmails, setCompanyEmails] = useState();
  const [email, setEmail] = useState('');
  const { isFetching, data, refetch } = useQuery(['payroll-summaries-config-emails'], async () => {
    if (companyId) {
      const result = await SettingsService.getPayrollSettingsEmails(companyId);
      setCompanyEmails(result);
    }
  });
  const deleteButton = (onClick: Function) => (
    <DataTableCellDeleteButton onClick={() => onClick()} style={{ width: '200px' }} />
  );

  const deleteEmail = (emailId: string) => {
    mutationDelete.mutate(emailId);
  };

  const mutation = useMutation(
    async (variables: { email: string; companyId: string }) => {
      await SettingsService.createPayrollSettingsEmails(variables);
    },
    {
      onSuccess: () => {
        AlertAdapter('Email Added!', 'success');
        refetch();
      },
      onError: () => {
        AlertAdapter('Fail on addind email!', 'error');
      },
    }
  );

  const mutationDelete = useMutation(
    async (emailId: string) => {
      await SettingsService.deletePayrollSettingsEmails(emailId);
    },
    {
      onSuccess: () => {
        AlertAdapter('Email Deleted!', 'success');
        refetch();
      },
      onError: () => {
        AlertAdapter('Fail deleting email!', 'error');
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [companyId]);

  const createEmailConfig = (body: { email: string; companyId: string }) => {
    mutation.mutate(body);
  };

  const columns = [
    {
      name: 'User Email',
      selector: (row: any) => row.email,
      sortable: true,
      sortField: 'date',
      width: '181px',
    },
    {
      cell: (row: any) => deleteButton(() => deleteEmail(row.id)),
    },
  ];

  const customStyles = {
    headRow: {
      style: {
        border: 'none',
      },
    },
    headCells: {
      style: {
        color: '#9399B2',
        font: 'normal normal bold 16px Biotif',
      },
    },
    rows: {
      style: {
        font: 'normal normal normal 14px Biotif',
        color: '#1B1D35',
        borderRadius: '5px',
        '&:not(:last-of-type)': {
          borderBottomWidth: '0px',
        },
      },
      stripedStyle: {
        color: '#1B1D35',
        backgroundColor: '#F3F4F8',
      },
      highlightOnHoverStyle: {
        backgroundColor: 'rgb(230, 244, 244)',
        borderBottomColor: '#FFFFFF',
        borderRadius: '25px',
        outline: '1px solid #FFFFFF',
      },
    },
    cells: {
      style: {
        justifyContent: 'left',
        '&:nth-of-type(2)': {
          width: '10px',
        },
      },
    },
  };

  const handleModalClose = () => {
    setPayrollModal(false);
  };
  return (
    <ReactModal
      isOpen={payrollModal}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '10px',
          margin: 'auto',
          width: '460px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          background: '#E4E4EB',
        },
      }}
      onRequestClose={handleModalClose}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <h2>Payroll Settings</h2>
          <h4 style={{ cursor: 'pointer' }} onClick={handleModalClose}>
            X
          </h4>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>
            <input
              type="email"
              onChange={(e: any) => {
                setEmail(e.target.value);
              }}
              style={{ width: '78%', paddingLeft: 13, height: '35px', borderRadius: '2px', border: '0px white solid' }}
            />
            <RegularButton disabled={!email} onClick={() => createEmailConfig({ email, companyId })}>
              ADD
            </RegularButton>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '100%', width: '98%' }}>
          <DefaultTable columns={columns} customStyles={customStyles} data={companyEmails || []} pagination={false} />
        </div>
      </div>
    </ReactModal>
  );
};
